<template>
  <div class="chart-component">
    <v-chart :options="chartOption" autoresize />
  </div>
</template>

<script>
import VChart from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/map";
import "echarts/lib/component/geo";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/dataset";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/map/js/world";

import variables from "@/styles/variables.scss";
import { basic, bar, barX, pie } from "./configs";
import { setChartStyle, setChartOptions } from "./helpers";

const chartsTypes = ["type-1", "type-2", "type-3"];

export default {
  components: { VChart },
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => null
    },
    type: {
      type: String,
      validator: val => chartsTypes.indexOf(val) !== -1,
      default: "type-1"
    },
    title: {
      type: String,
      default: ""
    },
    colors: {
      type: Array,
      default: () => null
    },
    noLegend: {
      type: Boolean,
      default: false
    },
    dataZoom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chartOption: null,

      chartsTypes,
      basic,
      bar,
      barX,
      pie
    };
  },
  watch: {
    theme() {
      this.setChart();
    },
    type() {
      this.setChart();
    },
    chartData() {
      this.setChart();
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    }
  },
  methods: {
    setChart() {
      setChartOptions(this);
      setChartStyle(this, variables);
    }
  },
  created() {
    this.setChart();
  }
};
</script>

<style lang="scss">
.chart-component {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;

  .echarts {
    min-height: 100%;
    width: 100%;
  }
}
</style>

<i18n>
{
  "ru": {
    "chart-type:type-1": "Linear",
    "chart-type:type-2": "Bar",
    "chart-type:type-3": "Bar-X",
    "chart-type:type-4": "Pie"
  },
  "en": {
    "chart-type:type-1": "Linear",
    "chart-type:type-2": "Bar",
    "chart-type:type-3": "Bar-X",
    "chart-type:type-4": "Pie"
  }
}
</i18n>
